// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeletonLoader_skeleton__R23Hx"};